import { Node, mergeAttributes } from "@tiptap/core";

const NoteVideo = Node.create({
    name: "noteVideo",
    group: "block",
    atom: true,
    draggable: true,

    addAttributes() {
        return {
            assetId: { default: null },
            src: { default: null },
            provider: { default: "upload" },
            poster: { default: null },
        };
    },

    parseHTML() {
        return [{ tag: "video[data-note-video]" }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "video",
            mergeAttributes(HTMLAttributes, {
                "data-note-video": "true",
                controls: "true",
            }),
        ];
    },
});

export default NoteVideo;
